export const SliderData = [
  {
    description:
        "Сегодня подруга смогла получить ВНЖ благодаря Вам хотя у неё сложнейшая ситуация была не смотря не на какие сложности довели дело до конца. Респект Вам 👏👏👏. Спасибо вам огромное, Аллах разы болсын 🙏.",
    image: null,
    alt: "Instagram отзыв",
    name: "@gunal2934",
    occ: "Instagram",
  },
  {
    description:
        "Люблю мастеров своего дела ❤️ 2 туристических внж быстро и без нервов. От души рекомендую 🙌",
    image: null,
    alt: "Instagram отзыв",
    name: "@petrushina_o",
    occ: "Instagram",
  },
  {
    description:
        "Огромная благодарность Вугару за помощь с оформлением ВНЖ! Я не владею турецким языком, а английский в общении с чиновниками, с которыми нужно общаться, не слишком помогает. Посмотрев как мучаются месяцами некоторые соотечественники, пытаясь оформить все документы самостоятельно, я решила что лучше будет обратиться за помощью. И мне действительно повезло что порекомендовали Вугара! Благодаря его помощи я оформила все документы буквально за пару дней, Вугар сопровождал меня во всех учреждениях куда приходилось обращаться, терпеливо разъяснял все вопросы, а их у меня было немало. Вскоре мне одобрили икамет на год, а теперь готова сама карточка! Искренне рекомендую Вугара как замечательного специалиста и отзывчивого человека!",
    image: null,
    alt: "Instagram отзыв",
    name: "@wise.wild.world",
    occ: "Instagram",
  },
  {
    description:
        "Огромное спасибо за помощь! Получила одобрение на ВНЖ! Рекомендую как настоящего профессионала своего дела!",
    image: null,
    alt: "Instagram отзыв",
    name: "@k.lekki79",
    occ: "Instagram",
  },
  {
    description:
        "Спасибо огромное, Вугар! Помог сделать документы в кратчайший срок, без каких-либо проблем. 🔥",
    image: null,
    alt: "Instagram отзыв",
    name: "@yuuechka",
    occ: "Instagram",
  },
  {
    description:
        "Çok sağolun Vugar bey 🙏 Bizim ikamet izin ve oturmak işlerimizi yaptınız çok zahmet olduk size Bana ve aileme verdiğiniz tüm yardımlar için çok teşekkür ederim 🙏🌹",
    image: null,
    alt: "Instagram отзыв",
    name: "@baghiiii_el",
    occ: "Instagram",
  },
];